module.exports = __webpack_public_path__ + "static/img/top_zhihui.9c7ef0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/top_zhihui.png
// module id = 3W9L
// module chunks = 1